import { Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { Modal } from '../../../../styles/global';
import { Button, CancelarButton, Text, Title } from './styles';

export default function ModalDelete({
  showModalDelete,
  setShowModalDelete,
  setConfirmDelete,
}) {
  const closeModal = () => {
    setShowModalDelete(false);
  };

  const onOk = () => {
    setConfirmDelete(true);
    closeModal();
  };

  return (
    <>
      <Modal
        title="Deletar linha"
        width={600}
        onCancel={closeModal}
        visible={showModalDelete}
        destroyOnClose={true}
        footer={[
          <>
            <CancelarButton
              key="cancel"
              onClick={closeModal}
              borderradius="4px"
            >
              Cancelar
            </CancelarButton>
            <Button key="submit" onClick={onOk} borderradius="4px">
              Sim, deletar
            </Button>
          </>,
        ]}
      >
        <Row justify="center">
          <Title>O que deseja fazer?</Title>
          <Text>
            Ao confirmar, você irá apagar todas as informações contidas na
            linha. Deseja continuar?
          </Text>
        </Row>
      </Modal>
    </>
  );
}

ModalDelete.propTypes = {
  showModalDelete: PropTypes.bool.isRequired,
  setShowModalDelete: PropTypes.func.isRequired,
  setConfirmDelete: PropTypes.func.isRequired,
};
